import { Star } from "lucide-react"
import { cn } from "@/lib/utils"

export function ReviewStars({
  rating,
  className,
}: {
  rating: number | null
  className?: string
}): React.ReactElement {
  const filledStars = rating ? Math.floor(rating) : 0

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {Array.from({ length: 5 }, (_, index) => (
        <Star
          key={index}
          className={cn(
            "h-4 w-4",
            index < filledStars
              ? "fill-yellow-400 text-yellow-400"
              : "text-muted-foreground/40",
          )}
        />
      ))}
    </div>
  )
}

export function StarRatingInput({
  value,
  onChange,
  disabled = false,
}: {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}): React.ReactElement {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }, (_, index) => {
        const starValue = index + 1
        return (
          <button
            key={starValue}
            type="button"
            className={cn(
              "rounded-sm p-1 transition-colors disabled:cursor-not-allowed",
              !disabled && "hover:bg-dashboard-warning-bg-soft",
            )}
            onClick={() => onChange(starValue)}
            disabled={disabled}
            aria-label={`Rate ${starValue} star${starValue === 1 ? "" : "s"}`}
            aria-pressed={starValue === value}
            title={`${starValue} star${starValue === 1 ? "" : "s"}`}
          >
            <Star
              className={cn(
                "h-5 w-5 transition-colors",
                starValue <= value
                  ? "fill-yellow-400 text-yellow-400"
                  : "text-muted-foreground/40 hover:text-yellow-300",
              )}
            />
          </button>
        )
      })}
    </div>
  )
}
